import { Expose, Transform } from 'class-transformer';

import { SnModel } from '@lib/common/models';

export class FsLprAxonVIUser extends SnModel {
  @Expose()
  public id: string;

  @Expose()
  public displayName: string;

  @Expose()
  public email: string;

  constructor(data?: any) {
    super();
    this.fromJSON(data);
  }
}
